module.exports = __webpack_public_path__ + "img/ae.6d497f1c.svg";